import { connect } from 'react-redux'
import ShoppingCart from '../components/ShoppingCartView'
import {
  loadProducts, selectPayment, removePayment, startPayPayments, updateCommonReceipt,
  selectAllPayments, updateReceivedAmount, selectPaymentOnDelete, printReceipt
} from '../modules/shoppingCart'
import {changeStep} from "../../../layouts/Content/modules/step";
import {getPayments, getTotalAmount, getChangeAmount, havePaymentInProcessing,
  showGeneralReceiptButton, showGeneralReceiptButtonLoading, showGeneralReceiptButtonSuccess,
  showGeneralReceiptButtonFail} from './selectors'

const mapDispatchToProps = {
  loadProducts: loadProducts,
  selectPayment: selectPayment,
  selectAllPayments: selectAllPayments,
  removePayment: removePayment,
  startPayPayments: startPayPayments,
  updateReceivedAmount: updateReceivedAmount,
  selectPaymentOnDelete: selectPaymentOnDelete,
  printReceipt: printReceipt,
  changeStep: changeStep,
  updateCommonReceipt: updateCommonReceipt
};

const mapStateToProps = (state) => ({
  payments: getPayments(state),
  total_amount: getTotalAmount(state),
  received_amount: state.cart.received_amount,
  change_amount: getChangeAmount(state),
  disabled_input: !getTotalAmount(state),
  show_change: getChangeAmount(state) > 0 && getChangeAmount(state) !== getTotalAmount(state),
  disable_pay_button: havePaymentInProcessing(state) || !getTotalAmount(state) || state.cart.received_amount < getTotalAmount(state),
  open_modal: !!(state.cart.payment_on_delete),
  payment_on_delete: state.cart.payment_on_delete,
  have_payment_in_processing: havePaymentInProcessing(state),

  receipt_url: state.cart.receipt_url,
  receipt_button_show: showGeneralReceiptButton(state),
  receipt_button_loading: showGeneralReceiptButtonLoading(state),
  receipt_button_success: showGeneralReceiptButtonSuccess(state),
  receipt_button_disabled: showGeneralReceiptButtonLoading(state) || showGeneralReceiptButtonFail(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(ShoppingCart)


// WEBPACK FOOTER //
// ./src/components/ShoppingCart/containers/ShoppingCartContainer.js